import { NextPageContext } from 'next';

const TRACKING_PARAM_KEYS = [
  '_gl',
  'gclid',
  'gbraid',
  'wbraid',
  'dclid',
  'gad_source',
  'gad_campaignid',
  'fbclid',
  'msclkid',
  'ttclid',
];

export const isTrackingParam = (key: string): boolean =>
  key.startsWith('utm_') || TRACKING_PARAM_KEYS.includes(key);

export const pickTrackingParams = (query: NextPageContext['query'] = {}): Record<string, string> =>
  Object.entries(query).reduce<Record<string, string>>((params, [key, value]) => {
    if (!isTrackingParam(key) || value === undefined) return params;
    return { ...params, [key]: Array.isArray(value) ? value[0] : String(value) };
  }, {});
